import axios from 'axios';
import APIURLMaker from './APIURLMaker';
import { normalizeUserPreferences } from '../shared/userPrefs/userPrefsDefaults';

/**
 * Fetch the authenticated user's global preferences.
 * @returns {Promise<Record<string, string>>}
 */
export async function fetchUserPrefs() {
  const url = APIURLMaker('userpref/getUserPref');
  const response = await axios.get(url);
  const preferences = response?.data?.preferences;
  return normalizeUserPreferences(preferences);
}

/**
 * Fetch allowed values (value + displayValue) for each preference key.
 * @returns {Promise<Record<string, Array<{ value: string, displayValue: string }>>>}
 */
export async function fetchUserPrefOptions() {
  const url = APIURLMaker('userpref/getUserPrefOptions');
  const response = await axios.get(url);
  return response?.data || {};
}

/**
 * Replace the full preference map for the authenticated user.
 * @param {Record<string, string>} preferences
 * @returns {Promise<Record<string, string>>}
 */
export async function saveUserPrefs(preferences) {
  const url = APIURLMaker('userpref/saveOrUpdateUserPref');
  const response = await axios.put(url, preferences);
  return normalizeUserPreferences(response?.data?.preferences);
}

/**
 * Update a single preference key.
 * @param {string} key
 * @param {string} value
 * @returns {Promise<Record<string, string>>}
 */
export async function saveUserPrefByKey(key, value) {
  const url = APIURLMaker(`userpref/saveOrUpdateUserPref/${encodeURIComponent(key)}`);
  const response = await axios.put(url, { value });
  return normalizeUserPreferences(response?.data?.preferences);
}
